import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
export function HowItWorks() {
  const steps = [{
    number: '1',
    title: 'Brief us (10-minute call)',
    description: "Tell us your audience, goals and format. We'll clarify what transformation you want."
  }, {
    number: '2',
    title: 'Get 2–3 curated speaker options',
    description: 'Every recommendation comes with transformation outcomes, topic examples, and fee guidance.'
  }, {
    number: '3',
    title: 'We handle the details',
    description: 'You get full speaker briefing, prep support, and a delivery process designed for smooth execution and clear post-talk ROI.'
  }];
  return <section className="py-24 bg-cream-100" data-id="element-74">
      <div className="max-w-7xl mx-auto px-6" data-id="element-75">
        <div className="text-center mb-16" data-id="element-76">
          <h2 className="text-3xl md:text-4xl font-heading text-navy-900 mb-4" data-id="element-77">
            How It Works
          </h2>
          <p className="text-lg text-gray-600" data-id="element-78">
            From Brief to Standing Ovation – Without the Risk
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-8 mb-12" data-id="element-79">
          {steps.map((step, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="bg-white p-8 rounded-xl shadow-sm hover:shadow-md transition-shadow relative overflow-hidden group" data-id="element-80">
              <div className="absolute top-0 left-0 w-full h-1 bg-gold-500 transform scale-x-0 group-hover:scale-x-100 transition-transform duration-300 origin-left" data-id="element-81"></div>
              <div className="text-6xl font-heading text-gold-500/20 mb-4 font-bold select-none" data-id="element-82">
                {step.number}
              </div>
              <h3 className="text-xl font-bold text-navy-900 mb-3 relative z-10" data-id="element-83">
                {step.title}
              </h3>
              <p className="text-gray-600 relative z-10" data-id="element-84">{step.description}</p>
            </motion.div>)}
        </div>

        <div className="text-center" data-id="element-85">
          <button className="bg-gold-500 hover:bg-gold-400 text-white px-8 py-4 rounded-lg font-semibold text-lg transition-colors shadow-md hover:shadow-lg inline-flex items-center gap-2" data-id="element-86">
            BOOK YOUR BRIEFING CALL <ArrowRight size={20} data-id="element-87" />
          </button>
        </div>
      </div>
    </section>;
}